import ExternalAccount from '/js/yext/externalaccounts/entities/listingslaunch/model/ExternalAccount';

type Context = {
  publisherIdToExternalAccount: Map<number, ExternalAccount>,
  setPublisherIdToExternalAccount:
      (publisherIdToExternalAccount: Map<number, ExternalAccount>) => void,
  publisherIdToUserLinkedExternalAccounts: Map<number, Array<ExternalAccount>>,
  setPublisherIdToUserLinkedExternalAccounts:
      (publisherIdToUserLinkedExternalAccounts: Map<number, Array<ExternalAccount>>) => void,
}

const ExternalAccountsContext = React.createContext<Context | undefined>(undefined);

export {ExternalAccountsContext};
